<template>
  <div class="main">
    <page-header />
    <div v-for="(option, i) in NoticeMessage.noticeInfo" :key="i">
      <marqueue v-if="option.noticeType == 0" />
    </div>

    <div class="conversation">
      <chat-message-box />
      <page-footer v-if="showPageFooter" />
    </div>
    <!--    评价与咨询客服-->
    <reconnect-model v-if="showReconnectModel" />
    <second-page v-if="dialogVisible" />
    <qeuquetimgout v-if="dialogtime" />
    <channel-time-out v-if="channeltime" />
    <order-list
      :direction="direction"
      @dialogHide="dialogHide"
      @checkOrder="orderchecked"
      ref="orderList"
      v-if="listStatus"
    />
  </div>
</template>
<script>
import pageHeader from "../components/page-header";
import marqueue from "../../components/marqueue";
import reconnectModel from "../components/reconnect-model";
import chatMessageBox from "../components/chat-message-box";
import pageFooter from "../components/page-footer";
import secondPage from "src/components/second-channel";
import qeuquetimgout from "src/components/equeuetimeout";
import channelTimeOut from "src/components/channeltimeout";
import orderList from "src/app/customer/components/orderList";
import store from "src/app/customer/store";
import utils from "src/app/customer/utils";
// import { reEnter } from "../../util
export default {
  name: "conversation",
  data() {
    return {
      direction: "rtl"
    };
  },
  components: {
    pageHeader,
    reconnectModel,
    chatMessageBox,
    pageFooter,
    secondPage,
    qeuquetimgout,
    channelTimeOut,
    orderList,
    marqueue
  },
  computed: {
    ...mapState({
      alreadyLogin: state => state.alreadyLogin,
      isConversation: state => state.isConversation,
      customerInfo: state => state.customerInfo,
      isShowEvaluatePage: state => state.isShowEvaluatePage,
      isQueue: state => state.isQueue,
      invalidFlag: state => state.invalidFlag,
      dialogVisible: state => state.dialogVisible,
      showNewChannelDialog: state => state.showNewChannelDialog,
      dialogtime: state => state.dialogtime,
      listStatus: state => state.listStatus,
      channeltime: state => state.channeltime,
      isShowNotice: state => state.isShowNotice,
      NoticeMessage: state => state.NoticeMessage,
      isConversationEnd: state => state.isConversationEnd
    }),
    showPageFooter() {
      //显示底部输入框的条件
      const { blackFlag } = this.customerInfo;

      return this.isConversation && blackFlag === 0;
    },
    showReconnectModel() {
      //显示重连与评价弹窗的条件
      return this.isShowEvaluatePage;
    }
  },
  created() {
    if (window.location.href.match(/localhost/)) {
      return;
    }
  },
  mounted() {
    store.commit("setState", { isreenter: 1 });
    // if (store.state.isQueue) {
    //   reEnter();
    // }
    if (window.history && window.history.pushState) {
      console.log("监听返回 pc");
      history.pushState(null, null, "#1");
      window.addEventListener("popstate", this.backChange, false);
      utils.reEnter();
    }

    const messageBox = document.querySelector("#messageBox");
    window.messageBox = messageBox;
    // setTimeout(() => {
    //   messageBox.scrollTop = messageBox.scrollHeight + 350;
    //   messageBox.scrollIntoView(messageBox.scrollHeight);
    // }, 500);
    // window.onresize = function temp() {
    //   location.reload();
    // };
  },
  methods: {
    dialogHide() {
      this.$store.commit("setState", { listStatus: false });
    },
    recheck() {
      this.$store.commit("setState", {
        listStatus: true,
        activeName: this.message.orderDetail.platformOrder.toString()
      });
    },
    orderchecked(item) {
      this.$store.commit("setState", { listStatus: false });
      utils.sendOrder(item);
      this.isShow = false;
    },
    resend(message) {
      let needData = JSON.parse(JSON.stringify(message));
      needData.resendType = 1;
      this.$store.dispatch("chat/sendMessage", needData, { root: true });
    },
    backChange() {
      history.pushState(null, null, "#1");
    }
  },
  beforeDestroy() {
    clearInterval(this.$store.state.queueTimer);
    window.removeEventListener("popstate", this.backChange, false);
  }
};
</script>

<style lang="less" scoped>
.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  .conversation {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
  }
}
</style>
